(() => {
  const products = {
    '/products/hush-gummies': { title: 'Hush Sleep Gummies', badge: 'Sleep', price: 'From $40' },
    '/products/shilajittablets': { title: 'Meru Shilajit Tablets', badge: 'Shilajit', price: 'From $55' },
    '/products/bluecrush': { title: 'Blue Crush Collagen', badge: 'Collagen', price: 'From $60' },
    '/products/shilajitgummy': { title: 'Deva Shilajit Gummies', badge: 'Shilajit', price: 'From $60' },
    '/products/eternity': { title: 'Eternity Mushroom Gummies', badge: 'Mushrooms', price: 'From $50' },
    '/products/cozy': { title: 'Cozy Adaptogenic Chai', badge: 'Chai', price: 'From $45' }
  };
  const hydratedVideos = new WeakSet();
  const observedVideos = new WeakSet();

  const renderProductTag = (media, product) => {
    if (!media) return;
    media.querySelectorAll(':scope > span:not(.hsf-cinema-card__tag-kicker)').forEach((node) => node.remove());

    let tag = media.querySelector('.hsf-cinema-card__tag');
    if (!tag) {
      tag = document.createElement('div');
      tag.className = 'hsf-cinema-card__tag';
      tag.append(document.createElement('span'), document.createElement('strong'), document.createElement('small'));
      media.appendChild(tag);
    }

    let kicker = tag.querySelector('span');
    let title = tag.querySelector('strong');
    let price = tag.querySelector('small');
    if (!kicker) {
      kicker = document.createElement('span');
      tag.appendChild(kicker);
    }
    if (!title) {
      title = document.createElement('strong');
      tag.appendChild(title);
    }
    if (!price) {
      price = document.createElement('small');
      tag.appendChild(price);
    }

    kicker.textContent = product.badge;
    title.textContent = product.title;
    price.textContent = product.price;
  };

  const renderIdentity = (body, product) => {
    if (!body) return;
    let identity = body.querySelector('.hsf-cinema-card__identity');
    let title = body.querySelector('h3');
    if (!identity) {
      identity = document.createElement('div');
      identity.className = 'hsf-cinema-card__identity';
      if (title) {
        title.replaceWith(identity);
        identity.appendChild(title);
      } else {
        title = document.createElement('h3');
        identity.appendChild(title);
        body.prepend(identity);
      }
    }

    let price = identity.querySelector('.hsf-cinema-card__price');
    if (!price) {
      price = document.createElement('p');
      price.className = 'hsf-cinema-card__price';
      identity.appendChild(price);
    }

    title.textContent = product.title;
    price.textContent = product.price;
  };

  const hydrateCinemaVideos = () => {
    const videos = Array.from(document.querySelectorAll('.hsf-cinema-reel video, .hsf-product-film video'));
    if (!videos.length) return;

    const canAutoplayPreview = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const load = (video) => {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.preload = 'auto';

      if (!video.src && video.dataset.hsfVideoSrc) {
        video.src = video.dataset.hsfVideoSrc;
      }
      if (video.readyState < 2) video.load();
    };
    const play = (video) => {
      load(video);
      video.play?.().catch(() => {});
    };

    videos.forEach((video) => {
      if (hydratedVideos.has(video)) return;
      hydratedVideos.add(video);

      const media = video.closest('.hsf-cinema-card__media') || video.closest('.hsf-product-film__media') || video;
      media.addEventListener('pointerenter', () => play(video), { once: true });
      media.addEventListener('focusin', () => play(video), { once: true });
    });

    if (!canAutoplayPreview) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            play(video);
          } else {
            video.pause?.();
          }
        });
      },
      { rootMargin: '180px 0px', threshold: 0.18 }
    );

    videos.forEach((video) => {
      if (observedVideos.has(video)) return;
      observedVideos.add(video);
      observer.observe(video);
    });
  };

  const installEditorialOverflowGuard = () => {
    if (document.getElementById('hsf-editorial-overflow-runtime')) return;

    const style = document.createElement('style');
    style.id = 'hsf-editorial-overflow-runtime';
    style.textContent = [
      'main .editorial-article-fullbleed, main .shopify-section--editorial-article { max-width: 100% !important; overflow-x: hidden !important; }',
      '@media (min-width: 769px) and (max-width: 1700px) {',
      'main .editorial-article-fullbleed .article .editorial-aside,',
      'main .editorial-article-fullbleed .article .margin-reading,',
      'main .shopify-section--editorial-article .article .editorial-aside,',
      'main .shopify-section--editorial-article .article .margin-reading { display: none !important; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  };

  const simplify = () => {
    installEditorialOverflowGuard();

    const reel = document.querySelector('.hsf-cinema-reel');
    if (!reel) return;

    const eyebrow = reel.querySelector('.hsf-cinema-reel__copy .hsf-eyebrow');
    const heading = reel.querySelector('.hsf-cinema-reel__copy h2');
    if (eyebrow) eyebrow.textContent = 'Product Films';
    if (heading) heading.textContent = 'Watch the formulas.';

    reel.querySelectorAll('.hsf-cinema-reel__copy p:not(.hsf-eyebrow), .hsf-cinema-reel__links, .hsf-cinema-card__body p').forEach((node) => node.remove());

    reel.querySelectorAll('.hsf-cinema-card').forEach((card) => {
      const mediaLink = card.querySelector('.hsf-cinema-card__media[href]');
      const href = mediaLink?.getAttribute('href') || '/collections/all';
      const path = href.startsWith('http') ? new URL(href).pathname : href;
      const product = products[path] || { title: 'Shop Formula', badge: 'Formula' };
      const body = card.querySelector('.hsf-cinema-card__body');

      renderProductTag(mediaLink, product);
      renderIdentity(body, product);
      if (mediaLink) mediaLink.setAttribute('aria-label', `Shop ${product.title}`);
      if (!body || body.querySelector('.hsf-cinema-card__cta')) return;

      const cta = document.createElement('a');
      cta.className = 'hsf-cinema-card__cta';
      cta.href = href;
      cta.textContent = 'Shop product';
      body.appendChild(cta);
    });

    hydrateCinemaVideos();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', simplify);
  } else {
    simplify();
  }
  window.setTimeout(simplify, 600);
  window.setTimeout(installEditorialOverflowGuard, 900);
  window.setTimeout(hydrateCinemaVideos, 1200);
})();
